module.exports = function() {
  return new Worker(__webpack_public_path__ + "eef044e0f20b09ffc8b4.worker.js");
};